import './AboutScreen.css';
import AboutIntro from './components/AboutIntro';
import PhotoGallery from './components/PhotoGallery';
import MembersSection from './components/MembersSection';
import MembershipBanner from '../../components/MembershipBanner';
import { useMembers, usePhotos } from './hooks/useAboutData';

function AboutScreen() {
  const { members, loading: membersLoading, error: membersError } = useMembers();
  const { photos, loading: photosLoading, error: photosError, loadMore, hasMore } = usePhotos();

  return (
    <div className="about-screen">
      <section className="about-hero">
        <h1>Chi Siamo</h1>
        <p>Scopri la nostra storia e missione</p>
      </section>

      <AboutIntro />
      
      <PhotoGallery 
        photos={photos} 
        loading={photosLoading} 
        error={photosError}
        loadMore={loadMore}
        hasMore={hasMore}
      />
      
      <MembershipBanner />
      
      <MembersSection 
        members={members} 
        loading={membersLoading} 
        error={membersError} 
      />
    </div>
  );
}

export default AboutScreen;
